import { useEffect } from 'react';

import { useDependencies } from '@servicetitan/react-ioc';

import { MOBILE_WEBVIEW_AXIOS_INSTANCE } from '@fleet-pro/mobile-webview-api';

import { useGlobalErrorInterceptor } from './use-global-error-interceptor';

export const useAxiosInterceptors = () => {
    const [axiosInstance] = useDependencies(MOBILE_WEBVIEW_AXIOS_INSTANCE);
    const { globalErrorInterceptor } = useGlobalErrorInterceptor();

    useEffect(() => {
        const interceptorId = axiosInstance.interceptors.response.use(
            response => response,
            globalErrorInterceptor
        );

        return () => {
            axiosInstance.interceptors.response.eject(interceptorId);
        };
    }, [axiosInstance, globalErrorInterceptor]);
};
